import {useNavigate} from 'react-router-dom';
import {Check, ChevronsUpDown} from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu';
import {useCurrentProvider} from '@/lib/providers/useCurrentProvider';
import {PROVIDERS, providerHomePath} from '@/config/providers';
import {cn} from '@/lib/utils/cn';

const KIND_LABEL: Record<string, string> = {
  document: 'Document based',
  schedule: 'Schedule based',
};

export function ProviderSwitcher() {
  const current = useCurrentProvider();
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Switch provider"
          className="w-full flex items-center gap-2 rounded-md border bg-background/60 px-2.5 py-2 text-left transition-colors hover:bg-muted"
        >
          <div className="flex flex-col leading-tight min-w-0 flex-1">
            <span className="text-sm font-medium truncate">
              {current.label}
            </span>
            <span className="text-[10px] text-muted-foreground uppercase tracking-widest">
              {KIND_LABEL[current.kind]}
            </span>
          </div>
          <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={4} className="w-[218px]">
        <DropdownMenuLabel>Provider</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {PROVIDERS.map(p => (
          <DropdownMenuItem
            key={p.id}
            // Switching provider lands on that provider's own home section —
            // the two families share no pages, so the current one rarely exists
            // on the other side.
            onSelect={() => navigate(providerHomePath(p))}
            className="justify-between gap-3"
          >
            <span className="flex flex-col leading-tight">
              <span>{p.label}</span>
              <span className="text-[10px] text-muted-foreground uppercase tracking-widest">
                {KIND_LABEL[p.kind]}
              </span>
            </span>
            <Check
              className={cn(
                'h-3.5 w-3.5 shrink-0',
                p.id === current.id ? 'opacity-100' : 'opacity-0'
              )}
            />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
